import client from '../base-api';

const authService = {
    login(loginData: { username: string, password: string }): Promise<any> {
        return client.post('/login', loginData);
    },
    forgotPassword(formData: any): Promise<any> {
        return client.put(`/forgot-password`, formData);
    },
    newPassword(formData: any): Promise<any> {
        return client.put(`/new-password`, formData);
    },
};

export default authService;
